import { createTheme, IconButton, ThemeProvider } from "@mui/material"

import { styled, Tab } from "@mui/material"

export const RightIcon = ({ disabled }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46.294"
    height="46.294"
    viewBox="0 0 46.294 46.294"
  >
    <g id="keyboard_arrow_down-24px" transform="translate(46.294) rotate(90)">
      <path
        id="Path_10185"
        data-name="Path 10185"
        d="M0,46.294H46.294V0H0Z"
        transform="translate(0 0)"
        fill="none"
      />
      <path
        id="Path_10186"
        data-name="Path 10186"
        d="M2.72,14.293l8.854-8.835,8.854,8.835,2.72-2.72L11.574,0,0,11.574Z"
        transform="translate(11.574 15.431)"
        fill={disabled ? "#1c56ce" : "#ffffff"}
      />
    </g>
  </svg>
)

export const LeftIcon = ({ disabled }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46.294"
    height="46.294"
    viewBox="0 0 46.294 46.294"
  >
    <g id="keyboard_arrow_down-24px" transform="translate(46.294) rotate(90)">
      <path
        id="Path_10185"
        data-name="Path 10185"
        d="M0,0H46.294V46.294H0Z"
        fill="none"
      />
      <path
        id="Path_10186"
        data-name="Path 10186"
        d="M8.72,8.59l8.854,8.835L26.427,8.59l2.72,2.72L17.574,22.883,6,11.31Z"
        transform="translate(5.574 7.98)"
        fill={disabled ? "#1c56ce" : "#ffffff"}
      />
    </g>
  </svg>
)

export const theme = createTheme({
  typography: {
    fontFamily: ["Poppins"].join(","),
  },
  palette: {
    primary: {
      main: "#ffffff",
    },
  },
})

export const CustomTab = styled(Tab)`
  margin-top: 8px;
  margin-right: 15px;
  border: none;
  height: 7vh;
  background: #1c56ce 0% 0% no-repeat padding-box;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
  color: #fff;
  flex-grow: 1;
`
